interface KpiCard {
  label: string;
  value: string | number;
  subtitle?: string;
}

interface KpiCardsProps {
  cards: KpiCard[];
}

export function KpiCards({ cards }: KpiCardsProps) {
  return (
    <div className="kpi-row">
      {cards.map((card, i) => (
        <div key={i} className="kpi-card">
          <div className="kpi-value">{card.value}</div>
          <div className="kpi-label">{card.label}</div>
          {card.subtitle && <div className="kpi-subtitle">{card.subtitle}</div>}
        </div>
      ))}
    </div>
  );
}
